import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface 현재 오픈된 메뉴의 메뉴 정보 (CD_MENU, NM_MENU, CD_MODULE...)
import SnButton from "@shared/components/SnButton";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnResizeBar from "@shared/components/SnResizeBar";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_SYS_AUT_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const searchRef = useRef<any>(null);
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();

        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region onSearch
  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_sys_aut_reg_003_01",
        params: searchRef.current.getFormdata(),
      };

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onInsert
  const onInsert = async () => {
    try {
      const newRow = {}; // 빈 객체
      //gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };
  //#endregion

  //#region onDelete
  const onDelete = async () => {
    //gridRefs.current["grid2"].current?.deleteSelectedRows();
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      gridRefs.current["grid2"].current.stopEditing();
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const changesRow = gridRefs.current["grid2"].current.getChange();
      const SaveData = {
        sys_usermenu: changesRow,
      };

      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      await fnSave("SN_SYS_AUT_REG_003_SAVE_01", SaveData);
      gridRefs.current["grid2"].current.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region onGrid1BtnsClick
  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApply") {
    }
  };
  //#endregion

  //#region onFocusedRowChanged
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_user = selectedRow.cd_user;
      gridRefs.current["grid2"].current.applyFilters({ cd_user: cd_user });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {},
      },
    }),
    [columns, dataSources]
  );
  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>

      <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
        <SnResizeBar direction={"width"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
              title: "코드",
              isEditable: false,
            }} // 기타 설정
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
              title: "상세코드",
            }} // 기타 설정
            events={grids.grid2.events}
          />
        </SnResizeBar>
      </div>
    </div>
  );
  //#endregion
});
export default SN_SYS_AUT_REG_003;
